import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const ProtectedRoute = ({ children, roles }) => {
  const { user,loading  } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user||!user.isAuthenticated) {
    return <Navigate to="/admin/login" />;
  }

  if (roles && (!user.role || !roles.some(role => user.role.includes(role)))) {
    return <Navigate to="/admin/unauthorized" />;
  }

  return children;
};

export default ProtectedRoute;
